import api from './api'

const ssoConfigService = {
  // Ánh xạ vai trò
  async listRoleMaps() {
    const res = await api.get('/sso/role-maps')
    return res.data
  },
  async createRoleMap(payload) {
    const res = await api.post('/sso/role-maps', payload)
    return res.data
  },
  async updateRoleMap(id, payload) {
    const res = await api.put(`/sso/role-maps/${id}`, payload)
    return res.data
  },
  async removeRoleMap(id) {
    const res = await api.delete(`/sso/role-maps/${id}`)
    return res.data
  },

  // Liên kết tài khoản
  async listAccountLinks() {
    const res = await api.get('/sso/account-links')
    return res.data
  },
  async createAccountLink(payload) {
    const res = await api.post('/sso/account-links', payload)
    return res.data
  },
  async removeAccountLink(id) {
    const res = await api.delete(`/sso/account-links/${id}`)
    return res.data
  },
}

export default ssoConfigService
